export default __webpack_public_path__ + "media/images/void-078405e67f7bb4878362b611606032ee.png";